export default __webpack_public_path__ + "static/media/sparkles_emoji.1e983893.png";